import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'
import { ButtonGroupModule } from '@shared-ui-lib/button-group/button-group.module'
import { ButtonModule } from '@shared-ui-lib/button/button.module'
import { LottieModule } from '@shared-ui-lib/lottie/lottie.module'

@Component({
    standalone: true,
    imports: [
        LottieModule,
        ButtonGroupModule,
        ButtonModule,
        CommonModule,
        LandingPageSectionContainerModule,
        TranslationModule,
    ],
    selector: 'app-landing-page-register-form-success',
    templateUrl: './landing-page-register-form-success.component.html',
    styleUrls: ['./landing-page-register-form-success.component.scss'],
})
export class LandingPageRegisterFormSuccessComponent {
    @Input() title?: string
    @Input() subTitle?: string
    @Input() showNextSteps?: boolean

    constructor(private router: Router) {}

    handleBackClick() {
        this.router.navigate(['/'])
    }
}
